// extracted by mini-css-extract-plugin
module.exports = {"scroll-button":"style_scroll-button__w5Nx3","scroll-button__trigger":"style_scroll-button__trigger__h_y6K"};